import { memo } from 'react';
// -*- mode: jsx;-*-

const FeatureShutOffMessageImpl = () => {
    return (
        <div className="shut-off-messaging">
            <h2>Due to heavy load, this section of our site isn&apos;t currently available.</h2>
            <p>Please check back in a bit.</p>
        </div>
    );
};
export const FeatureShutOffMessage = memo(FeatureShutOffMessageImpl);
